import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProductForm.module.css';

const Tab = ({ title, selected, onClick, disabled }) => (
  <button
    className={`naked-button ${styles.tab} ${selected ? styles.selected : ''}`}
    type="button"
    onClick={onClick}
    disabled={disabled}
  >
    <h4>{title}</h4>
  </button>
);
Tab.propTypes = {
  title: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
Tab.defaultProps = {
  disabled: false,
};

export default Tab;
